module.exports = __webpack_public_path__ + "img/jishu-2.d1c06b88.jpeg";